<template>
  <div>
    <b-container>
      <h3 class="text-left mt-2">Új jelszó beállítása</h3>
      <div class="bordered-container mt-5">
        <b-row>
          <b-col class="mt-3">
            <b-form>
              <b-form-group id="input-group-1" label-for="reset_password" description="">
                <b-input-group>
                  <b-form-input
                    id="reset_password"
                    :type="passwordFieldType"
                    required
                    placeholder="Új Jelszó"
                    v-model="password"
                    class="border"
                    @input="passwordCheck"
                  ></b-form-input>
                  <b-input-group-append>
                    <span class="input-group-text border" @click="switchPasswordVisibility">
                      <eye-icon v-if="passwordFieldType == 'password'" title="Jelszó megjelenítése" />
                      <eye-off-icon v-if="passwordFieldType == 'text'" title="Jelszó elrejtése" />
                    </span>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <b-form-group id="input-group-2" label-for="reset_password_confirm" description="">
                <b-input-group>
                  <b-form-input
                    id="reset_password_confirm"
                    :type="passwordFieldType"
                    required
                    placeholder="Jelszó megerősítése"
                    v-model="passwordConfirm"
                    class="border"
                  ></b-form-input>
                  <b-input-group-append>
                    <span class="input-group-text border" @click="switchPasswordVisibility">
                      <eye-icon v-if="passwordFieldType == 'password'" title="Jelszó megjelenítése" />
                      <eye-off-icon v-if="passwordFieldType == 'text'" title="Jelszó elrejtése" />
                    </span>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <div class="password-validator-container">
                <p v-bind:class="{ password_length_valid: truthyPasswordRulesCount1 }"></p>

                <p v-bind:class="{ uppercase_valid: truthyPasswordRulesCount2 }"></p>

                <p v-bind:class="{ number_valid: truthyPasswordRulesCount3 }"></p>

                <p v-bind:class="{ special_valid: truthyPasswordRulesCount4 }"></p>

                <p v-bind:class="{ hungarian_valid: truthyPasswordRulesCount5 }"></p>
              </div>
              <b-form-group>
                <small
                  class="form-text text-left text-muted"
                  v-bind:class="{
                    'text-success': valid_password_length,
                    'ml-1': valid_password_length,
                    'ml-4': !valid_password_length
                  }"
                >
                  Minimum 10 karakter
                </small>
                <small
                  class="form-text text-left text-muted"
                  v-bind:class="{
                    'text-success': contains_uppercase,
                    'ml-1': contains_uppercase,
                    'ml-4': !contains_uppercase
                  }"
                >
                  1 nagybetű
                </small>
                <small
                  class="form-text text-left text-muted"
                  v-bind:class="{
                    'text-success': contains_number,
                    'ml-1': contains_number,
                    'ml-4': !contains_number
                  }"
                >
                  1 szám
                </small>
                <small
                  class="form-text text-left text-muted"
                  v-bind:class="{
                    'text-success': contains_special,
                    'ml-1': contains_special,
                    'ml-4': !contains_special
                  }"
                >
                  1 különleges karakter ( @ $ ! % * ? &)
                </small>
                <small
                  class="form-text text-left text-muted"
                  v-bind:class="{
                    'text-success': contains_hungarian,
                    'ml-1': contains_hungarian,
                    'ml-4': !contains_hungarian
                  }"
                >
                  Nem tartalmaz ékezetes karaktert
                </small>
                <small
                  class="form-text text-left text-muted"
                  v-bind:class="{
                    'text-success': password == passwordConfirm && password != '',
                    'ml-1': password == passwordConfirm && password,
                    'ml-4': !(password == passwordConfirm && password)
                  }"
                >
                  A jelszavak megegyeznek
                </small>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                @click.prevent="onPasswordResetSubmission"
                :disabled="isLoading"
                class="mt-3"
              >
                <b-spinner small v-if="isLoading"></b-spinner>
                <span class="sr-only" v-if="isLoading">Betöltés...</span>
                <span v-if="!isLoading">Jelszó megváltoztatása</span>
              </b-button>
            </b-form>
            <br />
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import queryString from 'query-string'
import EyeIcon from 'vue-material-design-icons/Eye.vue'
import EyeOffIcon from 'vue-material-design-icons/EyeOff.vue'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      userId: 0,
      token: '',
      password: '',
      passwordConfirm: '',
      typed: false,
      contains_lowercase: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special: false,
      contains_hungarian: false,
      valid_password_length: false,
      valid_password: false,
      passwordFieldType: 'password'
    }
  },
  components: {
    EyeIcon,
    EyeOffIcon
  },
  computed: {
    ...mapGetters(['isLoading']),
    truthyPasswordRulesCount() {
      const rules = [
        this.valid_password_length,
        this.contains_uppercase,
        this.contains_number,
        this.contains_special,
        this.contains_hungarian
      ]
      const count = rules.filter(Boolean).length

      return count
    },
    truthyPasswordRulesCount1() {
      return this.truthyPasswordRulesCount >= 1 ? true : false
    },
    truthyPasswordRulesCount2() {
      return this.truthyPasswordRulesCount >= 2 ? true : false
    },
    truthyPasswordRulesCount3() {
      return this.truthyPasswordRulesCount >= 3 ? true : false
    },
    truthyPasswordRulesCount4() {
      return this.truthyPasswordRulesCount >= 4 ? true : false
    },
    truthyPasswordRulesCount5() {
      return this.truthyPasswordRulesCount >= 5 ? true : false
    }
  },
  methods: {
    switchPasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    async onPasswordResetSubmission() {
      if (
        !this.contains_lowercase ||
        !this.contains_number ||
        !this.contains_special ||
        !this.valid_password_length ||
        !this.contains_hungarian
      ) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Nem megfelelő jelszó erősség!' }
        })
        return
      }
      if (this.password != this.passwordConfirm) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'A jelszavak nem egyeznek.' }
        })
        return
      }

      const passwordResetData = {
        password: this.password,
        passwordResetToken: this.token,
        userId: this.userId
      }
      await this.$store.dispatch('resetPassword', passwordResetData)
      this.$router.push('/login')
    },
    passwordCheck() {
      this.password_length = this.password.length
      if (this.password_length >= 10) {
        this.valid_password_length = true
      } else {
        this.valid_password_length = false
      }

      if (this.password_length > 0) {
        this.typed = true
      } else {
        this.typed = false
      }
      this.contains_lowercase = /[a-z]/.test(this.password)
      this.contains_number = /\d/.test(this.password)
      this.contains_uppercase = /[A-Z]/.test(this.password)

      const specialPattern = /^(?=.*[@$!%*?&]).*$/
      this.contains_special = specialPattern.test(this.password)
      const hungarianCharactersPattern = /^(?:(?![űáéúőóüöí]).)*$/
      this.contains_hungarian = hungarianCharactersPattern.test(this.password)

      // Check if the password is valid
      if (this.contains_lowercase == true && this.contains_number == true) {
        this.valid_password = false
        if (this.contains_uppercase == true && this.valid_password_length == true) this.valid_password = true
      } else {
        this.valid_password = false
      }
    }
  },
  async created() {
    const params = queryString.parse(location.search)
    const { token } = params

    if (!token) {
      this.$router.push('/login')
    } else {
      try {
        const id = await this.$store.dispatch('validateResetToken', token)
        this.userId = id
        this.token = token
      } catch (err) {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.bordered-container {
  max-width: 600px;
  margin: 0;
}

.input-group-text {
  padding: 0rem 0.75rem;
  border: 0px !important;
  border-bottom: 1px solid rgba(0, 144, 60, 0.52) !important;
  border-radius: 0px;
  cursor: pointer;
}
</style>
